<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/wishlists/shared/product-add-to-wishlist/product-add-to-wishlist.component.ts
-->
<ng-template #anchor></ng-template>
